"use client"

import React, {JSX, PropsWithChildren} from "react";
import {CacheProvider} from "@emotion/react";
import {createTheme, ThemeProvider} from '@mui/material';
import createCache from '@emotion/cache';
import {prefixer} from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import {Vazirmatn} from "next/font/google";

const inter = Vazirmatn({subsets: ['arabic']})

const theme = createTheme({
    typography: {
        fontFamily: inter.style.fontFamily,
    }
});

export interface ColumnProps {
    className?: string;
}

function RTLContainer(props: PropsWithChildren<ColumnProps>): JSX.Element {

    const cacheRtl = createCache({
        key: 'muirtl',
        stylisPlugins: [prefixer, rtlPlugin]
    });
    return (
        <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={theme}>
                <div className={`w-full flex flex-col ${props.className}`}>
                    {props.children}
                </div>
            </ThemeProvider>
        </CacheProvider>
    );
}
export default RTLContainer